import { useFetch, useFetchCb } from '@gluedigital/ruse-fetch-extras'
import { QUERY_BUILDER_URL } from 'src/constants/global'
import { DashboardItem, DashboardListItem } from 'src/types/dashboard'

export interface DashboardResponse {
  ok: boolean
  dashboard: DashboardListItem
}
export const useDashboard = (id: string): DashboardListItem => {
  const { dashboard } = useFetch<DashboardResponse>(
    QUERY_BUILDER_URL + '/dashboard/' + id
  )
  return dashboard
}

export const useDashboardCRUD = () => {
  const doCreate = useFetchCb()
  const doUpdate = useFetchCb()
  const doDelete = useFetchCb()

  const createDashboard = async (data: {
    title?: string
    public?: boolean
    items?: DashboardItem[]
  }) => {
    const response = await doCreate(QUERY_BUILDER_URL + '/dashboard', {
      method: 'POST',
      body: data
    })
    return response as DashboardResponse
  }

  const updateDashboard = async (
    id: string,
    payload: Partial<DashboardListItem>
  ) => {
    const response = await doUpdate(QUERY_BUILDER_URL + '/dashboard/' + id, {
      method: 'PUT',
      body: payload
    })
    return response as DashboardResponse
  }

  const deleteDashboard = async (id: string) => {
    await doDelete(QUERY_BUILDER_URL + '/dashboard/' + id, {
      method: 'DELETE'
    })
  }

  return { createDashboard, updateDashboard, deleteDashboard }
}
